import { render, staticRenderFns } from "./CardForGroup.vue?vue&type=template&id=4c2a6c24&scoped=true"
import script from "./CardForGroup.vue?vue&type=script&lang=js"
export * from "./CardForGroup.vue?vue&type=script&lang=js"
import style0 from "./CardForGroup.vue?vue&type=style&index=0&id=4c2a6c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a6c24",
  null
  
)

export default component.exports